import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { CustomFieldService } from '../services/custom-field.service';

@Directive({
  selector: '[appBelgianNationalityNumber]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: BelgianNationalityNumberValidatorDirective,
    multi: true
  }]
})
export class BelgianNationalityNumberValidatorDirective implements Validator {
  @Input('appBelgianNationalityNumber') enabled: boolean | string = false;

  constructor(private customFieldService: CustomFieldService) { }

  validate(control: AbstractControl): ValidationErrors | null {
    if (!this.isEnabled()) {
      return null;
    }

    return this.customFieldService.isValidBelgianNationalityNumber(control.value)
      ? null
      : { belgianNationalityNumber: true };
  }

  private isEnabled(): boolean {
    return this.enabled === true || this.enabled === '' || this.enabled === 'true';
  }
}
